import { render, staticRenderFns } from "./ModalResetPassword.vue?vue&type=template&id=773ae7d4&scoped=true&"
import script from "./ModalResetPassword.vue?vue&type=script&lang=js&"
export * from "./ModalResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./ModalResetPassword.vue?vue&type=style&index=0&id=773ae7d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773ae7d4",
  null
  
)

export default component.exports